import {Box} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'

import type {ParentIssue} from '../../../../api/common-contracts'
import {ItemType} from '../../../../api/memex-items/item-type'
import type {FieldAggregate} from '../../../../hooks/use-aggregation-settings'
import {ProgressBar, ProgressBarVariants} from '../../../fields/progress-bar'
import {ItemState} from '../../../item-state'
import {AggregateLabels} from '../../aggregate-labels'
import {SanitizedGroupHeaderText} from '../sanitized-group-header-text'

type Props = {
  parentIssue: ParentIssue
  rowCount: number
  hideItemsCount: boolean
  aggregates: Array<FieldAggregate>
  titleSx?: BetterSystemStyleObject
}

export const ParentIssueGroupHeaderLabel: React.FC<Props> = ({
  parentIssue,
  rowCount,
  aggregates,
  hideItemsCount,
  titleSx,
}) => {
  const {total, completed, percentCompleted} = parentIssue.subIssueList
  return (
    <>
      <ItemState
        isDraft={false}
        state={parentIssue.state}
        stateReason={parentIssue.stateReason}
        type={ItemType.Issue}
        sx={{mr: 2}}
      />
      <SanitizedGroupHeaderText titleHtml={parentIssue.title} sx={titleSx} />
      <AggregateLabels
        counterSx={{color: 'fg.muted', ml: 2}}
        itemsCount={rowCount}
        aggregates={aggregates}
        hideItemsCount={hideItemsCount}
      />
      <Box sx={{ml: 3, width: 150}}>
        <ProgressBar
          variant={ProgressBarVariants.SOLID}
          total={total}
          completed={completed}
          percentCompleted={percentCompleted}
        />
      </Box>
    </>
  )
}

try{ ParentIssueGroupHeaderLabel.displayName ||= 'ParentIssueGroupHeaderLabel' } catch {}